<template>
  <div class="commission-details" ref="container">
    <div class="user">
      <div class="wrapper">
        <div class="myService baCololCom"  style="background-color: #ec5d59 !important;">
          <div class="title acea-row row-middle">我的业绩</div>
          <div class="nav acea-row row-middle baCololCom" style="background-color: #ec5d59 !important;">
            <router-link :to="{ path: '/user/income/' + userInfo._add_day }" class="item" >
              <div>今日业绩</div>
              <div class="num">{{ userInfo.todayIncome}}</div>
            </router-link>
            <router-link :to="{ path: '/user/income/' + userInfo._yestoday_day }" class="item" >
              <div>昨日业绩</div>
              <div class="num">{{ userInfo.yesdayIncome}}</div>
            </router-link>
            <router-link :to="{ path: '/user/income_week/' }" class="item" >
              <div>7日业绩</div>
              <div class="num">{{ userInfo.weekIncome}}</div>
            </router-link>
          </div>
          <div class="nav acea-row row-middle baCololCom" style="background-color: #ec5d59 !important;">
            <router-link :to="{ path: '/user/income_day/' + userInfo._add_month }" class="item"  >
              <div>本月业绩</div>
              <div class="num">{{ userInfo.tomonthIncome}}</div>
            </router-link>
            <router-link :to="{ path: '/user/income_day/' + userInfo._yest_month }" class="item"  >
              <div>上月业绩</div>
              <div class="num">{{ userInfo.yesmonthIncome}}</div>
            </router-link>
            <router-link :to="{ path: '/user/income_month' }" class="item"  >
              <div>总业绩</div>
              <div class="num">{{ userInfo.allIncome}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>


    <div class="sign-record" ref="content">
      <div class="list" v-if="info.length > 0">
          <table cellpadding="5" >
            <thead  class="item">
              <tr class="listn">
                <th align="center" >日期</th>
<!--                <th align="center" >左区</th>
                <th align="center" >右区</th>-->

                <th align="center" >团队</th>
                <th align="center" >直推</th>
                <th align="center" >操作</th>
              </tr>
            </thead>
            <tbody  v-for="(val, index) in info" :key="index" class="item">
                <tr   class="listn listn2">
                  <td align="center">{{val._add_month}}</td>
                  <td align="center">{{val.team_total_price}}<span class="showpvclass">({{val.team_total_pv}}pv)</span></td>
                  <td align="center">{{val.user_total_price}}<span class="showpvclass">({{val.user_total_pv}}pv)</span></td>
                  <td align="center"><router-link  :to="{ path: '/user/income_day/' + val._add_month }" class="bonus_show">明细</router-link></td>
                </tr>
<!--                <tr   class="listn listn2">
                  <td align="center">{{val._add_month}}</td>

                  <td align="center">{{val.team_total_pv_left}}元</td>
                  <td align="center">{{val.team_total_pv_right}}元</td>

                  &lt;!&ndash;<td align="center">{{val.team_total_pv}}元</td>&ndash;&gt;
                  &lt;!&ndash;<td align="center">{{val.user_total_pv}}元</td>&ndash;&gt;
                  <td align="center"><router-link  :to="{ path: '/user/income_day/' + val._add_month }" class="bonus_show">明细</router-link></td>
                </tr>-->
            </tbody>

          </table>
      </div>

      <div class="shoppingCart">
        <div  style="margin-top:0px;"
              class="noCart"
              v-if="showno === 0"
        >
          <div class="pictrue"><img src="@assets/images/noList.png" /></div>
        </div>
      </div>

    </div>

    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style scoped>
.footer-line-height {
  height: 1rem;
}
.baCololCom {
  background-color:#ec5d59 !important;
  color:#fff;
}
.baCololCom div{
  color:#fff !important;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.user .wrapper .myService {
  margin-bottom:0.15rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
</style>
<style>
  .sign-record .list .item .listn th{
    padding:0.15rem 0px;
  }
  .sign-record .list .item .listn .listntime {
    padding-left:0.15rem;
  }
  .sign-record .list .item .listn td{
    padding:0.30rem 0px;
  }
  .sign-record .list .item .listn{
    font-size: 0.28rem;
    color: #282828;

  }
  .sign-record .list .item .listn2{
    border-bottom:1px solid #eee;
  }
  .bonus_show {
    color:#ec5d59;
    font-size:0.3rem;
  }
</style>
<script>
import {getIncomeListMonth, getUser} from "../../../api/user";
import Loading from "@components/Loading";
const NAME = "IncomeMonth";
export default {
  name: NAME,
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      showno:1,
      userInfo: {},
      info: [],
        allBonus:[],
        commission: 0,
        commission_pv: 0,

        my_commission: 0,
        my_commission_pv: 0,
        allBonusCountCan:2,
      where: {
        page: 1,
        limit: 20,
      },
      types: 3,
      loaded: false,
      loading: false
    };
  },

  mounted: function() {
    this.User();
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
      });
    },
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
        getIncomeListMonth(that.where).then(
        res => {
          that.loading = false;
          that.allBonus = res.data.allBonus;
          that.loaded = res.data.list.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data.list);
          that.commission = res.data.teammoney;
          that.commission_pv = res.data.teampv;
          that.my_commission = res.data.mymoney;
          that.my_commission_pv = res.data.mypv;

          if(that.info.length==0){
            that.showno=0;
          }else{
            that.showno=1;
          }
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
